import React, { Suspense } from 'react';
import './App.css';
import { Switch, Route } from 'react-router-dom';
import Privacy from './Footer/Privacy';
import Terms from './Footer/Terms';
import Disclaimer from './Footer/Disclaimer';
import MainScreen from './MainScreen/MainScreen';
import Eula from './Footer/Eula';
import NotFoundPage from './404/NotFoundPage';
import Login from './Authentification/Login';

const AdminRoute = React.lazy(() => import('./Admin/AdminRoute'));

function App() {
  return (
    <div className="App">
      <Switch>
        <Route exact path="/" component={MainScreen} />
        <Route path="/privacy-policy" component={Privacy} />
        <Route path="/terms-and-conditions" component={Terms} />
        <Route path="/disclaimer" component={Disclaimer} />
        <Route path="/eula" component={Eula} />
        <Route path="/admin-admin" render={() => (
          <Suspense fallback={<div className="route-loading">Loading Atlas Sport…</div>}>
            <AdminRoute />
          </Suspense>
        )} />
        <Route path="/login-login" component={Login} />
        <Route path="*" component={NotFoundPage} />
      </Switch>
    </div>
  );
}

export default App;
